import { render } from "./PledgePayment.vue?vue&type=template&id=130c2d0a&scoped=true"
import script from "./PledgePayment.vue?vue&type=script&lang=js"
export * from "./PledgePayment.vue?vue&type=script&lang=js"

import "./PledgePayment.vue?vue&type=style&index=0&id=130c2d0a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130c2d0a"]])

export default __exports__